// extracted by mini-css-extract-plugin
export default {"inputGroup":"AccountDeleteModal_inputGroup__wJiv-","fullWidth":"AccountDeleteModal_fullWidth__50Xit"};